<template>
  <div v-if="!!project && project.entrepreneur">
    <v-card-text id="card-entrepreneurName-text" flat>
      <label
        class="details-subtitle"
        v-if="showField('entrepreneurName') && project.entrepreneur.name"
        v-html="project.entrepreneur.name"
      ></label>
      <div
        class="entrepreneurName-item"
        v-if="showField('entrepreneurType') && project.entrepreneur.type"
        v-html="project.entrepreneur.type"
      ></div>
    </v-card-text>

    <v-card-text
      id="card-entrepreneurAbout-text"
      flat
      v-if="showField('entrepreneurAbout') && project.entrepreneur.about"
    >
      <label class="details-subtitle">Sobre</label>
      <div
        class="entrepreneurAbout-item"
        v-html="project.entrepreneur.about"
      ></div>
    </v-card-text>

    <!-- TODO: Locais de atuação dos projetos -->
    <v-card-text
      id="card-entrepreneurFoundedOn-text"
      flat
      v-if="showField('entrepreneurFoundedOn') && project.entrepreneur.foundedOn"
    >
      <label class="details-subtitle">Data de Fundação</label>
      <div
        class="entrepreneurFoundedOn-item"
        v-html="formatDate(project.entrepreneur.foundedOn)"
      ></div>
    </v-card-text>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { getBRDate } from "@/utils/DateUtils";
  export default {
    name: "PollViewEntrepreneur",
    data: () => ({}),
    computed: {
      ...mapState(["publicPoll", "project"]),
    },
    methods: {
      urlImage(typeImage, id) {
        return require(`../../../pages/image/${typeImage}/${id}.png`);
      },
      showField(fieldName) {
        if (this.project === null || this.project == undefined) {
          return false;
        }
        return this.publicPoll.configuration.projectDataForDisplay[fieldName];
      },
      formatDate(dateStr) {
        return getBRDate(dateStr);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/poll/view/Entrepreneur.vue